var REACT_ELEMENT_TYPE;function _jsx(e, r, E, l) {REACT_ELEMENT_TYPE || (REACT_ELEMENT_TYPE = "function" == typeof Symbol && Symbol.for && Symbol.for("react.element") || 60103);var o = e && e.defaultProps,n = arguments.length - 3;if (r || 0 === n || (r = { children: void 0 }), 1 === n) r.children = l;else if (n > 1) {for (var t = Array(n), f = 0; f < n; f++) t[f] = arguments[f + 3];r.children = t;}if (r && o) for (var i in o) void 0 === r[i] && (r[i] = o[i]);else r || (r = o || {});return { $$typeof: REACT_ELEMENT_TYPE, type: e, key: void 0 === E ? null : "" + E, ref: null, props: r, _owner: null };}import { Form } from 'react-redux-form';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import Immutable, { is, fromJS } from 'immutable';
import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { Icon } from "../../UI";

import { debounce } from "../../utils";
import libraryHelper, { prepareDefaultFilters } from "../helpers/libraryFilters";
import { searchDocuments } from "../actions/libraryActions";
import { Translate } from "../../I18N";
import { wrapDispatch } from "../../Multireducer";
import { FilterTocGeneration } from "../../ToggledFeatures/tocGeneration";
import { TemplatesFilter } from "./TemplatesFilter";
import { AssigneeFilter } from "./AssigneeFilter";
import { withRouter } from "../../componentWrappers";
import { PermissionsFilter } from "./PermissionsFilter";
import { PublishedFilters } from "./PublishedFilters";
import Filters from "./FiltersFromProperties";

class FiltersForm extends Component {
  constructor(props) {
    super(props);
    this.search = debounce(() => {
      this.props.searchDocuments({
        location: this.props.location,
        navigate: this.props.navigate
      });
    }, 300);

    this.submit = this.submit.bind(this);
    this.onChange = this.onChange.bind(this);
    this.activateAutoSearch = () => {
      this.autoSearch = true;
    };

    this.state = { documentTypeFromFilters: true };
  }

  shouldComponentUpdate(nextProps, nextState) {
    return (
      !is(this.props.fields, nextProps.fields) ||
      !is(this.props.aggregations, nextProps.aggregations) ||
      !is(this.props.documentTypes, nextProps.documentTypes) ||
      !is(this.state.documentTypeFromFilters, nextState.documentTypeFromFilters));

  }

  onChange() {
    if (this.autoSearch) {
      this.autoSearch = false;
      this.search();
    }
  }

  submit() {
    this.props.searchDocuments({ location: this.props.location, navigate: this.props.navigate });
  }

  render() {
    const { templates, documentTypes } = this.props;
    const aggregations = this.props.aggregations.toJS();
    const translationContext =
    documentTypes.get(0) || (templates.get(0) || fromJS({})).get('_id') || 'System';
    const allFields = this.props.fields.toJS();
    const showNoValueOnFilters = allFields.size;
    let fields = libraryHelper.
    parseWithAggregations(allFields.slice(0), aggregations, showNoValueOnFilters).
    filter((field) => !field.options || field.options.length);

    if (!documentTypes.size) {
      fields = prepareDefaultFilters(fields);
    }

    const model = `${this.props.storeKey}.search`;

    return (/*#__PURE__*/
      _jsx("div", { className: "filters-box" }, void 0, /*#__PURE__*/
      _jsx(Form, { model: model, id: "filtersForm", onSubmit: this.submit, onChange: this.onChange }, void 0, /*#__PURE__*/
      _jsx(PublishedFilters, { onChange: this.activateAutoSearch, aggregations: aggregations }), /*#__PURE__*/
      _jsx(PermissionsFilter, { onChange: this.activateAutoSearch, aggregations: aggregations }), /*#__PURE__*/
      _jsx(TemplatesFilter, {}), /*#__PURE__*/
      _jsx(Filters, {
        onChange: this.activateAutoSearch,
        properties: fields,
        translationContext: translationContext,
        storeKey: this.props.storeKey }
      ), /*#__PURE__*/

      _jsx(FilterTocGeneration, { onChange: this.activateAutoSearch, aggregations: aggregations }), /*#__PURE__*/
      _jsx(AssigneeFilter, { onChange: this.activateAutoSearch, aggregations: aggregations })
      ),

      (() => {
        const activeTypes = templates.filter((template) =>
        documentTypes.includes(template.get('_id'))
        );
        if (activeTypes.size > 0 && fields.length === 0) {
          return (/*#__PURE__*/
            _jsx("div", { className: "blank-state" }, void 0, /*#__PURE__*/
            _jsx(Icon, { icon: "times" }), /*#__PURE__*/
            _jsx("h4", {}, void 0, /*#__PURE__*/
            _jsx(Translate, {}, void 0, "No common filters")
            ), /*#__PURE__*/
            _jsx("p", {}, void 0, /*#__PURE__*/
            _jsx(Translate, { translationKey: "no filters for templates" }, void 0, "The combination of entity types doesn't have any filters in common."

            )
            ), /*#__PURE__*/
            _jsx("a", {
              href: "https://github.com/huridocs/uwazi/wiki/Filter",
              target: "_blank",
              rel: "noopener noreferrer" }, void 0, /*#__PURE__*/

            _jsx(Translate, {}, void 0, "Learn more")
            )
            ));

        }

        return null;
      })()
      ));

  }
}












function mapStateToProps(state, props) {
  return {
    fields: state[props.storeKey].filters.get('properties'),
    aggregations: state[props.storeKey].aggregations,
    templates: state.templates,
    documentTypes: state[props.storeKey].filters.get('documentTypes')
  };
}

function mapDispatchToProps(dispatch, props) {
  return bindActionCreators({ searchDocuments }, wrapDispatch(dispatch, props.storeKey));
}

export { FiltersForm, mapStateToProps };
export default connect(mapStateToProps, mapDispatchToProps)(withRouter(FiltersForm));